<template>
  <div class="gx-sd">
<!--    <h1 class="gx-main__title">店铺数据</h1>-->
    <template v-if="!isProductDetail">
        <!-- 筛选栏 -->
        <div class="gx-sd__filter">
          <div class="gx-sd__filter-item">
            <div class="gx-sd__filter-label">店铺分组</div>
            <el-select v-model="searchData.group_ids" placeholder="全部" clearable size="mini" @change="loadAll">
              <el-option v-for="g in groupList" :key="g.id" :value="g.id" :label="g.name"></el-option>
            </el-select>
          </div>
          <div class="gx-sd__filter-item">
            <div class="gx-sd__filter-label">统计日期</div>
            <el-date-picker
                style="border:none;width: 200px;font-size: 12px;padding: 0;"
                v-model="selectDay"
                type="daterange"
                range-separator="-"
                size="mini"
                @change="changeDate"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </div>
<!--          <select v-model="searchData.group_ids" class="gx-sd__select" @change="loadAll">
            <option value="">全部分组</option>
            <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
          </select>
          <input v-model="searchData.start_time" class="gx-sd__input" placeholder="开始日期" type="date" @change="changeTime"/>
          <span class="gx-sd__dash">—</span>
          <input v-model="searchData.end_time" class="gx-sd__input" placeholder="结束日期" type="date" @change="changeTime"/>-->
          <div class="gx-sd__shortcuts">
            <button
              v-for="s in shortcuts"
              :key="s.label"
              class="gx-sd__shortcut"
              :class="{ 'gx-sd__shortcut--on': shortcut === s.label }"
              @click="applyShortcut(s)"
            >{{ s.label }}</button>
          </div>
        </div>

        <!-- 利润看板 -->
        <div class="gx-sd__board" v-if="!isZoomIn">
          <div class="gx-sd__board-tabs">
            <button
              v-for="p in ['抖店']"
              :key="p"
              class="gx-sd__board-tab"
              :class="{ 'gx-sd__board-tab--on': profitPlatform === p }"
              @click="profitPlatform = p"
            >{{ p }}利润看板</button>
          </div>
          <div class="gx-sd__board-body">
            <div v-for="(grp, gi) in activeStatGroups" :key="grp.title" class="gx-sd__grp">
              <div class="gx-sd__grp-head">
                <span class="gx-sd__grp-bar" :style="{ background: grp.bar }"></span>
                <span class="gx-sd__grp-title">{{ grp.title }}</span>
                <span class="gx-sd__grp-desc">— {{ grp.desc }}</span>
              </div>
              <div class="gx-sd__grp-items" :style="{ gridTemplateColumns: grp.last ? 'repeat(3,1fr)' : 'repeat(10,1fr)' }">
                <div
                  v-for="(s, si) in grp.items"
                  :key="si"
                  class="gx-sd__item"
                  :class="{ 'gx-sd__item--last': grp.last, 'gx-sd__item--key': isKey(s.label) }"
                >
                  <div class="gx-sd__item-label">{{ s.label }}</div>
                  <div class="gx-sd__item-value">{{ s.v }}</div>
                  <div class="gx-sd__item-mom">
                    <span v-if="s.up === true" class="gx-sd__mom-arrow">▲</span>
                    <span v-if="s.up === false" class="gx-sd__mom-arrow gx-sd__mom-arrow--down">▼</span>
                    <span>月环比 {{ s.mom }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 排行表 -->
        <div class="gx-sd__rank custom-el-wrapper">
          <div class="gx-sd__rank-search">
            <div class="gx-sd__rank-tabs">
              <button
                v-for="t in rankTabs"
                :key="t.id"
                class="gx-sd__rank-tab"
                :class="{ 'gx-sd__rank-tab--on': rankTab === t.id }"
                @click="switchRank(t.id)"
              >{{ t.label }}</button>
            </div>

            <button :title="`${isZoomIn?'收起':'放大'}利润看板`" class="gx-sd__rank-zoom" :class="{'gx-sd__rank-zoom--out': isZoomIn}" @click="isZoomIn=!isZoomIn">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" v-if="!isZoomIn"><path d="M1 5V1h4M8 1h4v4M1 8v4h4M8 12h4V8" stroke="#666" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" ></path></svg>
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" v-else><path d="M2 5h4V1M11 5H7V1M2 8h4v4M11 8H7v4" stroke="#C8443C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" ></path></svg>
            </button>

          </div>
          <div class="gx-sd__ran-filter custom-form-wrap">
            <el-form inline size="mini">
              <el-form-item>
                <el-select v-model="selectShop" filterable placeholder="店铺名称" @change="loadRank(1)">
                  <el-option  v-for="item in shopList" :key="item.id"  :label="item.shop_name" :value="item.shop_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input v-model="keys_input" placeholder="商品名称" @blur="loadRank(1)" style="width:180px"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <!-- 店铺排行 -->
          <div v-if="rankTab === 'shop'" class="gx-sd__table">
            <table>
              <thead>
                <tr>
                  <th v-for="(h,i) in shopRankCols" :key="i">{{ h.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in shopRank" :key="r.shop_id || r.ranking">
                  <td class="gx-sd__mono" v-for="(h,i) in shopRankCols" :key="i">
                    <template v-if="h.key==='ranking'">
                      <span class="gx-sd__rank-no gx-sd__rank-no--one" v-if="r.ranking==1||r.scope==1">👑</span>
                      <span class="gx-sd__rank-no gx-sd__rank-no--two" v-else-if="r.ranking==2||r.scope==2">👁️</span>
                      <span class="gx-sd__rank-no gx-sd__rank-no--three" v-else-if="r.ranking==3||r.scope==3">3</span>
                      <span class="gx-sd__rank-no" v-else>{{ r.ranking || r.scope || '--' }}</span>
                    </template>
                    <template v-else-if="h.key==='shop_name'">
                      <div class="gx-sd__shop-name">
                        <div class="gx-sd__shop-name-icon" v-if="r.shop_name">{{r.shop_name[0]}}</div>
                        <span>{{ r.shop_name || '--' }}</span>
                      </div>
                    </template>
                    <template v-else-if="h.key==='all_sales'">
                      <span class="gx-sd__red">{{ r.all_sales || '--' }}</span>
                    </template>
                    <template v-else-if="h.key==='all_total_profit'">
                      <span :class="Number(r.all_total_profit)<0?'gx-sd__red':'gx-sd__green'">{{ r.all_total_profit || '--' }}</span>
                    </template>
                    <template v-else>
                      {{ [h.key]?r[h.key]: '--' }}
                    </template>
                  </td>
                </tr>
                <tr v-if="!shopRank.length">
                  <td :colspan="shopRankCols.length" class="gx-sd__empty">暂无排行数据</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 款式排行 -->
          <div v-else class="gx-sd__table">
            <table>
              <thead>
                <tr>
                  <th v-for="(h,i) in styleRankCols" :key="i">{{ h.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in styleRank" :key="r.goods_id || r.id || r.ranking">
                  <td class="gx-sd__mono" v-for="(h,i) in styleRankCols" :key="i">
                    <template v-if="h.key==='ranking'">
                      <span class="gx-sd__rank-no gx-sd__rank-no--one" v-if="r.ranking==1||r.scope==1">1</span>
                      <span class="gx-sd__rank-no gx-sd__rank-no--two" v-else-if="r.ranking==2||r.scope==2">2</span>
                      <span class="gx-sd__rank-no gx-sd__rank-no--three" v-else-if="r.ranking==3||r.scope==3">3</span>
                      <span class="gx-sd__rank-no" v-else>{{ r.ranking || r.scope || '-' }}</span>
                    </template>
                    <template v-else-if="h.key==='img'">
                      <img v-if="r.img" :src="r.img" class="gx-sd__product-img" @click="viewDetails(r)"/>
                    </template>
                    <template v-else-if="h.key==='name'">
                      <div class="gx-sd__product-name" @click="viewDetails(r)">{{ r.name || '--' }}</div>
                    </template>
                    <template v-else-if="h.key==='all_total_profit'">
                      <span :class="Number(r.all_total_profit)<0?'gx-sd__red':'gx-sd__green'">{{ r.all_total_profit || '--' }}</span>
                    </template>
                    <template v-else-if="h.key.indexOf('_rate')>-1">
                      {{ [h.key]? displayRate(r[h.key]): '--' }}
                    </template>
                    <template v-else>
                      {{ [h.key]? displayValue(r[h.key]): '--' }}
                    </template>
                  </td>
                </tr>
                <tr v-if="!styleRank.length">
                  <td :colspan="styleRankCols.length" class="gx-sd__empty">暂无排行数据</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style="padding: 10px 14px;background: #EEF1F6;">
            <Pagination :total="rankTotal" :page.sync="rankPage" :limit.sync="rankLimit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="loadRank(rankPage)"  layout="total, sizes, prev, pager, next, jumper" />
          </div>
        </div>
    </template>
    <ProductDetail ref="productDetailRef" @back="isProductDetail=false" v-else></ProductDetail>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ProductDetail from "./productDetail.vue";
import Pagination from '../../components/newUi/Pagination.vue'

const rankTableCols=[
      {label:'TOP',key:'ranking'},
      {label:'全店营业额',key:'all_sales'},
      {label:'订单量',key:'all_sales_orders'},
      {label:'采购量',key:'all_purchase'},
      {label:'采购应收',key:'all_purchase_order_amount'},
      {label:'采购应付',key:'all_purchase_amount'},
      {label:'发货量',key:'all_shipping_num'},
      {label:'代发费',key:'all_shipping_fee'},
      {label:'达人佣金',key:'all_influencer_commission'},
      {label:'权益保险',key:'all_shipping_insurance'},
      {label:'千川费用',key:'all_qianchuan_fee'},
      {label:'发货前仅退款单数',key:''},
      {label:'发货前仅退款金额',key:''},
      {label:'发货前仅退款率',key:''},
      {label:'退货退款量',key:'all_refund_num'},
      {label:'退货退款额',key:'all_refund_fee'},
      {label:'换货订单量',key:''},
      {label:'待上游退款金额',key:'all_wait_refund_amount'},
      {label:'退单率',key:''},
      {label:'仅退款单数',key:''},
      {label:'仅退款金额',key:''},
      {label:'平台服务费',key:'all_shop_service_fee'},
      {label:'消费者赔付',key:''},
      {label:'判罚扣款',key:'all_violation_compensation'},
      {label:'评价有礼',key:''},
      {label:'上门取件运费',key:''},
      {label:'小额打款',key:'all_small_amount_payment'},
      {label:'货损量',key:''},
      {label:'货损金额',key:''},
      {label:'异常订单数',key:''},
      {label:'异常订单额',key:''},
      {label:'运费险',key:''},
      {label:'报销总额度',key:''},
      {label:'毛利润',key:'all_total_profit'},
      {label:'毛利率',key:''},
      // {label:'超时赔付',key:'all_timeout_compensation'},
    ]
export default {
  name: 'NewShopDataPage',
  components: {
    Pagination,
    ProductDetail
  },
  data() {
    return {
      isZoomIn:false,//排行榜放大缩小
      searchData: { group_ids: '', start_time: '', end_time: '' },
      selectDay:[],
      groupList: [],
      shopList:[],
      selectShop:'',
      keys_input:'',
      shortcuts: [
        { label: '今天', days: 0 },
        { label: '昨天', days: 1 },
        { label: '近7天', days: 7 },
        { label: '近30天', days: 30 },
        { label: '近60天', days: 60 },
        { label: '近90天', days: 90 },
        { label: '近180天', days: 180 },
        { label: '近一年', days: '365'},
        { label: '本月', days: 'this_month'},
        { label: '上月', days: 'prev_month'}
      ],
      shortcut: '',
      profitPlatform: '抖店',
      summary: {},
      rankTabs: [
        { id: 'shop', label: '店铺排行' },
        { id: 'style', label: '款式排行' }
      ],
      rankTab: 'shop',
      shopRank: [],
      styleRank: [],
      rankPage: 1,
      rankLimit: 20,
      rankTotal: 0,
      // shopRankCols: ['TOP', '店铺名', '全店营业额', '订单量', '采购量', '采购应收', '采购应付', '退货退款量', '退货退款额', '权益保险', '达人佣金', '超时赔付', '判罚扣款', '小额打款', '平台服务费', '千川', '发货量', '代发费', '毛利润'],
      // styleRankCols: ['TOP', '商品图', '商品名', '店铺名', '全部销售额', '全部采购应收', '全部采购应付', '全部单数', '全部毛利', '全部毛利率', '全部退单数', '全部退单率'],
      refreshTimer:null,
      sortField:'',//排序字段
      sortValue:'',//排序值asc-升序 desc-降序
      isProductDetail:false,//商品详情
    }
  },
  computed: {
    shopRankCols(){
      let list = [...rankTableCols]
      list.splice(1,0,{label: '店铺名',key:'shop_name'})
      return list
    },
    styleRankCols(){
      let list = [...rankTableCols]
      list.splice(1,0,{label: '商品图',key:'img'})
      list.splice(2,0,{label: '商品名',key:'name'})
      return list
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.rankTotal / this.rankLimit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.rankPage - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    isKey() {
      const keys = ['全部销售额', '全部销售单数', '合计毛利润', '合计毛利率', '全店营业额']
      return (label) => keys.includes(label)
    },
    activeStatGroups() {
      const d = this.summary || {}
      const v = (key) => (d[key] !== undefined && d[key] !== null ? d[key] : '--')
      const rate = (key) => this.displayRate(v(key))
      const g = (bar, last, items) => ({ bar, last, title: items.title, desc: items.desc, items: items.items })
      return [
        g('#D4A946', false, {
          title: '营收 & 采购大盘',
          desc: '核心业务规模，先看收入与进货',
          items: [
            { label: '全部销售额', v: v('all_sales'), mom: '—', up: null },
            { label: '全部销售单数', v: v('all_sales_orders'), mom: '—', up: null },
            { label: '全部采购量', v: v('all_purchase'), mom: '—', up: null },
            { label: '全部采购应收', v: v('all_purchase_order_amount'), mom: '—', up: null },
            { label: '全部采购应付', v: v('all_purchase_amount'), mom: '—', up: null },
            { label: '全部发货量', v: v('all_shipping_num'), mom: '—', up: null },
            { label: '全部代发费', v: v('all_shipping_fee'), mom: '—', up: null },
            { label: '全部达人佣金', v: v('all_influencer_commission'), mom: '—', up: null },
            { label: '全部权益保险', v: v('all_shipping_insurance'), mom: '—', up: null },
            { label: '全部千川费用', v: v('all_qianchuan_fee'), mom: '—', up: null },
          ]
        }),
        g('#4CAF7A', false, {
          title: '售后退款类',
          desc: '退货率 · 发货前后退货量 · 退款金额 · 换货订单',
          items: [
            { label: '总退货率', v: v(''), mom: '—', up: null },
            { label: '发货前仅退货率', v: v(''), mom: '—', up: null },
            { label: '发货后退货率', v: v(''), mom: '—', up: null },
            { label: '全部退货量', v: v(''), mom: '—', up: null },
            { label: '发货前仅退货量', v: v(''), mom: '—', up: null },
            { label: '发货后退货量', v: v(''), mom: '—', up: null },
            { label: '发货前仅退款金额', v: v('all_refund_only_amount'), mom: '—', up: null },
            { label: '发货后退货金额', v: v(''), mom: '—', up: null },
            { label: '换货订单量', v: v('all_exchange_order_num'), mom: '—', up: null },
            { label: '待上游退款金额', v: v('all_wait_refund_amount'), mom: '—', up: null },

            /*{ label: '发货前仅退款单数', v: v('all_refund_only_num'), mom: '—', up: null },
            { label: '发货前仅退款率', v: v('all_refund_only_amount'), mom: '—', up: null },
            { label: '全部退货退款量', v: v('all_refund_num'), mom: '—', up: null },
            { label: '全部退货退款金额', v: v('all_refund_fee'), mom: '—', up: null },
            { label: '全部退单率', v: v('all_return_rate'), mom: '—', up: null },
            { label: '仅退款单数', v: v('all_refund_only_num'), mom: '—', up: null },
            { label: '仅退款金额', v: v('all_refund_only_amount'), mom: '—', up: null },*/
          ]
        }),
        g('#3FB6E0', false, {
          title: '平台费用 & 赔付杂费',
          desc: '各类扣点、罚款、运费成本',
          items: [
            { label: '全部平台服务费', v: v('all_shop_service_fee'), mom: '—', up: null },
            { label: '全部消费者赔付', v: v('all_timeout_compensation'), mom: '—', up: null },
            { label: '全部判罚扣款', v: v('all_violation_compensation'), mom: '—', up: null },
            { label: '全部评价有礼', v: v('all_evaluate_fee'), mom: '—', up: null },
            { label: '上门取件运费', v: v('all_pick_up_shipping'), mom: '—', up: null },
            { label: '全部小额打款', v: v('all_small_amount_payment'), mom: '—', up: null },
            { label: '货损量', v: v('all_loss_num'), mom: '—', up: null },
            { label: '货损金额', v: v('all_loss_amount'), mom: '—', up: null },
            { label: '异常单数量', v: v('all_abnormal_num'), mom: '—', up: null },
            { label: '异常单金额', v: v('all_abnormal_amount'), mom: '—', up: null },
          ]
        }),
        g('#E85D5D', true, {
          title: '最终盈利结果',
          desc: '报表收尾，利润核心指标',
          items: [
            { label: '报销总金额', v: v('all_reimbursement_amount'), mom: '—', up: null },
            { label: '合计毛利润', v: v('all_total_profit'), mom: '—', up: null },
            { label: '合计毛利率', v: rate('all_total_profit_rate'), mom: '—', up: null }
          ]
        })
      ]
    }
  },
  created() {
    this.loadGroups()
    this.loadRank(1)
    this.refreshTimer = setInterval(() => {
      this.loadSummary()
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
  methods: {
    ...mapActions({
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      opGetStatisticData: 'ucenter_order/opGetStatisticData',
      opGetStatisticRanking: 'ucenter_order/opGetStatisticRanking'
    }),
    loadGroups() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    loadSummary() {
      const params = {shop_id :this.selectShop||'',...this.buildStatisticParams()}
      this.opGetStatisticData({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            const summary = {}
            const list = res.data && Array.isArray(res.data.list) ? res.data.list : []
            list.forEach((item) => {
              if (item && item.key) summary[item.key] = item.val
            })
            this.summary = summary
          } else {
            this.summary = {}
            this.$message.error(res.msg || res.message || '获取店铺数据失败')
          }
        }
      })
    },
    buildStatisticParams() {
      const params = {}
      if (this.searchData.group_ids) params.group_ids = [this.searchData.group_ids]
      if (this.searchData.start_time && this.searchData.end_time) {
        params.start_time = this.searchData.start_time
        params.end_time = this.searchData.end_time
      } else {
        params.select_day = '0'
      }
      return params
    },
    loadRank(page) {
      this.rankPage = page
      const params = Object.assign({
        limit: this.rankLimit,
        page: this.rankPage,
        type: this.rankTab === 'shop' ? 1 : 2,
        keys: 'product_name',
        keys_input: this.keys_input||'',
        shop_id:  this.selectShop||'',
      }, this.buildStatisticParams())
      if (this.rankPage > 1 && this.shopList.length) {
        params.need_shop_list = 0
      }
      this.opGetStatisticRanking({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            const pageData = res.data && res.data.list ? res.data.list : {}
            const list = Array.isArray(pageData.data) ? pageData.data : (Array.isArray(pageData) ? pageData : [])
            if (this.rankTab === 'shop') this.shopRank = list
            else this.styleRank = list
            this.rankTotal = pageData.total || 0
            this.shopList =res.data && res.data.shop_list ? res.data.shop_list : []

          } else {
            if (this.rankTab === 'shop') this.shopRank = []
            else this.styleRank = []
            this.rankTotal = 0
            this.$message.error(res.msg || res.message || '获取排行数据失败')
          }
        }
      })
    },
    switchRank(id) {
      this.rankTab = id
      this.loadRank(1)
    },
    applyShortcut(s) {
      this.shortcut = s.label
      let end = new Date()
      let start = new Date()
      if(this.shortcut ==='本月'){
        start = new Date(end.getFullYear(), end.getMonth(), 1);
        end = new Date(start.getFullYear(), start.getMonth() + 1, 0)
     }else if(this.shortcut ==='上月'){
        start = new Date(end.getFullYear(), end.getMonth()-1, 1);
        end = new Date(start.getFullYear(), start.getMonth()+1, 0)
     }else{
        start.setDate(start.getDate() - s.days)
      }
      const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
      this.searchData.start_time = fmt(start)
      this.searchData.end_time = fmt(end)
      this.loadAll()
    },
    changeDate(){
      if (this.selectDay) {
        this.searchData.start_time = this.selectDay[0];
        this.searchData.end_time = this.selectDay[1]
        this.shortcut = ''
        this.searchData.select_day = ''
      } else {
        this.searchData.start_time = ''
        this.searchData.end_time = ''
        this.shortcut = this.shortcuts[0].label
        this.searchData.select_day = this.shortcuts[0].days
      }
      this.loadAll()
    },
    changeTime(){
      if(this.searchData.start_time&&this.searchData.end_time||(!this.searchData.start_time&&!this.searchData.end_time)){
        this.loadAll()
      }
    },
    resetSearch() {
      this.searchData = { group_ids: '', start_time: '', end_time: '' }
      this.shortcut = ''
      this.loadAll()
    },
    displayValue(value) {
      return value === undefined || value === null || value === '' ? '--' : value
    },
    displayRate(value) {
      const result = this.displayValue(value)
      return result === '--' || String(result).includes('%') ? result : `${result}%`
    },
    loadAll() {
      this.loadSummary()
      this.loadRank(1)
    },
    viewDetails(r){
      this.isProductDetail = true
      this.$nextTick(()=>{
        this.$refs.productDetailRef.show(r.goods_id)
      })
    }
  }
}
</script>

<style scoped>
.gx-sd__filter {
  background: #FFFFFF;
  border-radius: 8px;
  border: 2px solid #E0E0EC;
  padding: 11px 14px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.gx-sd__filter-item{
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #E0E0EC;
  border-radius: 4px;
  gap: 8px;
}
.gx-sd__filter-label{
  font-size: 12px;
  line-height: 28px;
  color: #999999;
}
.gx-sd__filter-item :deep(.el-input__inner){
  border: none;
  padding-left: 0;
  padding-right: 0;
}
.gx-sd__select {
  height: 28px;
  padding: 0 8px;
  border: 2px solid #E0E0EC;
  border-radius: 4px;
  outline: none;
  font-size: 11px;
  color: #1A1A2E;
  background: #FFFFFF;
  min-width: 120px;
}
.gx-sd__input {
  width: 108px;
  height: 28px;
  padding: 0 8px;
  border: 2px solid #E0E0EC;
  border-radius: 4px;
  outline: none;
  font-size: 11px;
  color: #1A1A2E;
  background: #FFFFFF;
  box-sizing: border-box;
}
.gx-sd__input:focus {
  border-color: rgba(212, 169, 70, .65);
}
.gx-sd__dash {
  color: #999;
  font-size: 12px;
}
.gx-sd__shortcuts {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
}
.gx-sd__shortcut {
  height: 26px;
  padding: 0 9px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 11px;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  color: #666;
  transition: all .13s;
  white-space: nowrap;
}
.gx-sd__shortcut--on {
  background: #E1E5EE;
  border-color: rgba(212, 169, 70, .5);
  color: #D4A946;
}
.gx-sd__spacer {
  flex: 1;
}
.gx-sd__btn {
  height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  cursor: pointer;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  font-size: 12px;
  color: #666;
  transition: all .15s;
}
.gx-sd__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-sd__board {
  background: #FFFFFF;
  border-radius: 8px;
  border: 2px solid #E0E0EC;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  overflow: hidden;
}
.gx-sd__board-tabs {
  display: flex;
  border-bottom: 1px solid #E0E0EC;
  background: #EEF1F6;
}
.gx-sd__board-tab {
  padding: 10px 24px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  background: transparent;
  color: #666;
  border-bottom: 2px solid transparent;
  transition: all .15s;
}
.gx-sd__board-tab--on {
  background: #E1E5EE;
  color: #D4A946;
  font-weight: 600;
  border-bottom-color: #D4A946;
}
.gx-sd__board-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-sd__grp-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}
.gx-sd__grp-bar {
  width: 3px;
  height: 13px;
  border-radius: 2px;
  flex-shrink: 0;
}
.gx-sd__grp-title {
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-sd__grp-desc {
  font-size: 11px;
  color: #4A4A6A;
}
.gx-sd__grp-items {
  display: grid;
  gap: 6px;
}
.gx-sd__item {
  border-radius: 6px;
  padding: 9px 10px 8px;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
}
.gx-sd__item--last {
  padding: 14px 16px 12px;
}
.gx-sd__item--key {
  background: rgba(212, 169, 70, .1);
  border-color: rgba(212, 169, 70, .3);
  box-shadow: 0 2px 8px #E1E5EE;
}
.gx-sd__item-label {
  font-size: 10px;
  color: #4A4A6A;
  margin-bottom: 4px;
  line-height: 1.3;
  min-height: 24px;
}
.gx-sd__item--last .gx-sd__item-label {
  font-size: 11px;
  min-height: 0;
}
.gx-sd__item-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 700;
  color: #1A1A2E;
  line-height: 1;
}
.gx-sd__item--last .gx-sd__item-value {
  font-size: 20px;
}
.gx-sd__item--key .gx-sd__item-value {
  font-size: 15px;
  color: #D4A946;
}
.gx-sd__item-mom {
  font-size: 10px;
  color: #999;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.gx-sd__mom-arrow {
  font-size: 8px;
  color: #52C41A;
}
.gx-sd__mom-arrow--down {
  color: #C8443C;
}
.gx-sd__rank {
  background: #FFFFFF;
  border-radius: 8px;
  border: 2px solid #E0E0EC;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}
.gx-sd__rank-search{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gx-sd__rank-tabs {
  display: flex;
  border-bottom: 1px solid #E0E0EC;
  align-items: center;
}
.gx-sd__rank-tab {
  padding: 10px 22px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  background: #F5F0E8;
  color: #666;
  border-bottom: 2px solid transparent;
  transition: all .15s;
}
.gx-sd__rank-tab--on {
  background: #fff;
  color: #C8443C;
  font-weight: 600;
  border-bottom-color: #C8443C;
}
.gx-sd__rank-zoom{
  width: 30px;
  height: 30px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid rgb(224, 224, 236);
  background: rgb(255, 255, 255);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.gx-sd__rank-zoom:hover, .gx-sd__rank-zoom--out{
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
}
.gx-sd__ran-filter{
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 9px 14px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
  flex-wrap: wrap;
}
.gx-sd__table {
  overflow-x: auto;
}
.gx-sd__table table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
.gx-sd__table th {
  padding: 10px 14px;
  text-align: left;
  background: #EEF1F6;
  font-size: 11px;
  font-weight: 500;
  color: #606266;
  border-bottom: 1px solid #E0E0EC;
  letter-spacing: .04em;
}
.gx-sd__table td {
  padding: 10px 14px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid #f5f5f5;
}
.gx-sd__table tr:hover td {
  background: #F5F0E8;
}
.gx-sd__table::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.gx-sd__table::-webkit-scrollbar-thumb {
  background: rgba(212, 169, 70, .35);
  border-radius: 2px;
}
.gx-sd__table::-webkit-scrollbar-track {
  background: #F4F6F8;
}
.gx-sd__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-sd__dim {
  color: #6A6A8A;
}
.gx-sd__red {
  font-weight: 600;
  color: rgb(200, 68, 60)
}
.gx-sd__green{
  color: rgb(82, 196, 26)
}
.gx-sd__rank-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(245, 245, 245);
  font-size: 11px;
  font-weight: 700;
  color: #999999;
}
.gx-sd__rank-no--one{
  font-size: 14px;
  background: rgb(255, 215, 0);
  color: rgb(255, 255, 255);
}
.gx-sd__rank-no--two{
  font-size: 14px;
  background: rgb(192,192,192);
  color: rgb(255, 255, 255);
}
.gx-sd__rank-no--three{
  background: rgb(205, 127, 50);
  color: rgb(255, 255, 255);
}
.gx-sd__shop-name {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgb(26, 26, 46);
  font-weight: 500;
}
.gx-sd__shop-name-icon{
  width: 24px;
  height: 24px;
  border-radius: 5px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 205, 210);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Serif SC", serif;
  font-size: 11px;
  font-weight: 700;
  color: rgb(200, 68, 60);
  flex-shrink: 0;
}
.gx-sd__product-img {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
}
.gx-sd__product-name {
  max-width: 180px;
  color: rgb(63, 182, 224)!important;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-sd__profit {
  color: #C8443C;
  font-weight: 600;
}
.gx-sd__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}
.gx-sd__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid #E0E0EC;
  background: #eef1f6;
}
.gx-sd__pager-total {
  font-size: 11px;
  color: #999999;
}
.gx-sd__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-sd__page {
  min-width: 28px;
  height: 26px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #E0E0EC;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #4A4A6A;
}
.gx-sd__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-sd__page--on {
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color:rgb(200, 68, 60);
  font-weight: 700;
}
@media (max-width: 1200px) {
  .gx-sd__grp-items {
    grid-template-columns: repeat(5, 1fr) !important;
  }
}
</style>
